import { Outlet } from 'react-router-dom';

export const AttendanceOutlet = () => <Outlet />;
